import { render, staticRenderFns } from "./DisasterDialog.vue?vue&type=template&id=579e6c67&scoped=true"
import script from "./DisasterDialog.vue?vue&type=script&lang=js"
export * from "./DisasterDialog.vue?vue&type=script&lang=js"
import style0 from "./DisasterDialog.vue?vue&type=style&index=0&id=579e6c67&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579e6c67",
  null
  
)

export default component.exports